import { render, staticRenderFns } from "./PriceListUpdate.vue?vue&type=template&id=4e46d79c&"
import script from "./PriceListUpdate.vue?vue&type=script&lang=js&"
export * from "./PriceListUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports